import PrivacyPolicy from "../model/PrivacyPolicy";
import ApiPromise from "../infrastructure/apiClient/ApiPromise";
import * as apiClient from "../infrastructure/apiClient/apiClient";

const savePrivacyPolicy = (policy: PrivacyPolicy): ApiPromise<any> => {
    return ApiPromise.fromAxiosPromise(apiClient.privacyPolicy.put(policy));
}

export default savePrivacyPolicy;
